enum LoadingStatus {
    IDLE,
    LOADING,
    LOADED,
    FAILED,
}

export default LoadingStatus
